import { createStore, withProps, select } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { persistState, localStorageStrategy } from '@ngneat/elf-persist-state';
import { Injectable } from '@angular/core';

interface IUiState {
  isOpenedSidenav: boolean | null;
  widthSidenav: string;
  isShowSupport: boolean
  // loading: boolean;
}

// initialize a store with a state
const uiStore = createStore(
  { name: 'ui' },
  withProps<IUiState>({ isOpenedSidenav: false, widthSidenav: '300px', isShowSupport: true })
);

export const uiPersist = persistState(uiStore, {
  key: 'ui',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class UiRepository {
  isOpenedSidenav$: Observable<boolean | null> = uiStore.pipe(
    select((state) => state.isOpenedSidenav)
  );

  // loading$: Observable<boolean> = uiStore.pipe(
  //   select((state) => state.loading)
  // );

  widthSidenav$: Observable<string | null> = uiStore.pipe(
    select((state) => state.widthSidenav)
  );

  isShowSupport$: Observable<boolean | null> = uiStore.pipe(
    select((state) => state.isShowSupport)
  );

  // setLoading(loading: IAuthState['loading']): void {
  //   uiStore.update((state) => ({
  //     ...state,
  //     loading,
  //   }));
  // }

  updateIsOpenedSidenav(isOpenedSidenav: IUiState['isOpenedSidenav']) {
    uiStore.update((state) => ({
      ...state,
      isOpenedSidenav,
    }));
  }

  updateIsShowSupport(isShowSupport: IUiState['isShowSupport']) {
    uiStore.update((state) => ({
      ...state,
      isShowSupport,
    }));
  }
}
